<script setup lang="ts">
import { getFormats } from '~~/shared/utils/product-catalogue';const props = defineProps<{
  variant: SingleProductVariant
}>()
</script>

<template>
  <section class="mt-(--outer-padding) grid md:grid-cols-[minmax(0,18rem)_minmax(0,1fr)] lg:grid-cols-[minmax(0,18rem)_minmax(0,1fr)_minmax(0,18rem)] items-start gap-5 lg:gap-11 rounded-sm rounded-br-(--roundness) bg-(--theme-5) p-5 lg:p-11">
    <div class="cover mx-auto flex w-full flex-col gap-4 text-center">
      <CrystallizeImage v-if="variant.cover?.url" :image="variant.cover" img-class="rounded-sm" />
      <div v-else class="placeholder aspect-3/4 w-full" />
      <a
        v-if="variant.browsableLink"
        :href="variant.browsableLink"
        target="_blank"
        class="mx-auto flex items-center gap-2 text-[smaller]"
      >
        <UIcon name="far:book-open" />
        <span>Bla i boken</span>
      </a>
    </div>

    <div class="text-sm md:row-span-2 lg:row-auto">
      <h4 class="text-xl font-semibold group-hover:underline" v-text="variant.title" />
      <p v-if="variant.subtitle" v-text="getFormats(variant).join(', ')" class="font-semibold mb-8" />
      <UiAboutUnibok
        v-if="variant.formats?.includes('digitalbok')"
        class="font-normal mb-8"
        :prefix="true"
        :title="variant.title?.replace(/unibok/i, '').trim()"
      />
      <div
        v-else-if="variant.description"
        class="font-normal mb-8"
        v-html="variant.description"
      />

      <dl class="grid grid-cols-2 gap-3 [&_dt]:font-bold">
        <div v-if="variant.authors?.length" class="col-span-2">
          <dt v-if="variant.authors.length === 1">Forfatter</dt>
          <dt v-else>Forfattere</dt>
          <dd>{{ variant.authors }}</dd>
        </div>

        <div v-if="variant.releaseDate">
          <dt>Utgitt</dt>
          <dd>{{ formatNorwegianDate(variant.releaseDate) }}</dd>
        </div>

        <div v-if="variant.grades?.length">
          <dt>Klassetrinn</dt>
          <dd>{{ variant.grades.map((it) => it.replace('aarstrinn', '')).join(', ') }}</dd>
        </div>

        <div v-if="variant.sku">
          <dt>ISBN/varenr.</dt>
          <dd>{{ variant.sku }}</dd>
        </div>

        <div v-if="variant.release">
          <dt>Utgave</dt>
          <dd>{{ variant.release }}</dd>
        </div>
      </dl>
    </div>

    <UiSingleProductNewCta :variant="variant" />
  </section>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

.placeholder {
  background: rgba(var(--variant-background), 0.2);
}

section {
  /* @media screen and (min-width: theme('screens.md')) {
    --img-max-width: 15.625rem;
    display: grid;
    gap: 3.75rem;
    grid-template-columns: var(--img-max-width) minmax(0, 1fr);

    .cover {
      max-width: var(--img-max-width);
    }
  } */

  .details {
    --inner-padding: 0.75rem;
    padding: var(--inner-padding);

    @media screen and (min-width: theme('screens.md')) {
      --inner-padding: 0;
    }
  }
}
</style>
